import React from 'react';
import StyledQuote from './quote.style';
import Headline from '../../atoms/headline/headline';
import Copy from '../../atoms/copy/copy';
import QuoteIcon from '../../icons/quote/quote';
import Image from '../../atoms/image/image';

export type QuoteProps = {
  copy?: string;
  source?: string;
  wide?: boolean;
  color?: string;
  image?: {
    url?: string;
    alt?: string;
  };
};

const Quote = ({ copy, source, wide, color, image }: QuoteProps) => (
  <StyledQuote color={color} wide={wide}>
    <div className="quote__content">
      {image && <Image {...image} className="quote__image" />}
      <Headline secondary className="quote__quotation">
        <span className="quote__icon">
          <QuoteIcon />
        </span>
        {copy}
      </Headline>

      {source && <Copy className="quote__author">{source}</Copy>}
    </div>
  </StyledQuote>
);

export default Quote;
